import { render } from "./kjcgzh.vue?vue&type=template&id=6b267402&scoped=true"
import script from "./kjcgzh.vue?vue&type=script&lang=js"
export * from "./kjcgzh.vue?vue&type=script&lang=js"

import "./kjcgzh.vue?vue&type=style&index=0&id=6b267402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b267402"]])

export default __exports__